// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateLaborAdditiveSummaryModalVisibility = (state, action) => action.isVisible;

export default (state = getDefaultState().isVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY_MODAL_VISIBILITY]: updateLaborAdditiveSummaryModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/home-page/reducers/labor-additive-summary-modal-visibility.js